import useAsyncEffect from "use-async-effect";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import Card from "../../../../components/card";
import CustomPagination from "../../../../components/CustomPagination/CustomPagination";
import {utils, writeFile} from "xlsx";

const LocationDataStateCityWise = () => {
    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    let [selectedValue, setSelectedValue] = useState("State")

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();
    const [locationJsonResult, setLocationJsonResult] = useState([]);
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(5);
    let [total, setTotal] = useState(0)

    function getCurrentDate(){
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function handleChangePage(event, newpage) {
        setpg(newpage);
    }

    function handleChangeRowsPerPage(event) {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getLocationDemographicsByState() {
        var url = CROMPTON_ANALYTICS_URL + "v1/user/location/states"
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            let totalNumber = 0
            //console.log(res.data)

            var state = []
            var count = [];
            for (var i = 0; i < res.data.length; i++) {
                state.push(res.data[i].state);
                count.push(res.data[i].count);
                totalNumber = totalNumber + res.data[i].count
            }

            setLocationJsonResult(res.data)
            setTotal(totalNumber)

        }).catch((error) => {
            //console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    function getLocationDemographicsByCity() {
        var url = CROMPTON_ANALYTICS_URL + "v1/user/location/cities"
        axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {
            let totalNumber = 0
            //console.log(res.data)

            var state = []
            var count = [];
            for (var i = 0; i < res.data.length; i++) {
                state.push(res.data[i].city);
                count.push(res.data[i].count);
                totalNumber = totalNumber + res.data[i].count
            }

            setLocationJsonResult(res.data)
            setTotal(totalNumber)

        }).catch((error) => {
           // console.log(error)
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    }

    useAsyncEffect(async () => {
            getLocationDemographicsByState()

        }, [selectedValue]
    );

    function handleStateCityDropDown() {
        const selectBox = document.getElementById("stateCityBox")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)

        if (selectedValue === "State" || selectedValue === "state") {
            getLocationDemographicsByState("states")
        }
        if (selectedValue === "City" || selectedValue === "city") {
            getLocationDemographicsByCity()
        }
        //getInActiveDevicesTrend(selectedValue.toLowerCase())
    }

    function exportLocationData(){
        let filteredData
        if(selectedValue === "State"){
            filteredData = locationJsonResult.map((item) => ({
                State: item.state,
                Count: item.count

                // Assuming address is a nested object
            }));
        }
        if(selectedValue === "City"){
            filteredData = locationJsonResult.map((item) => ({
                City: item.city,
                Count: item.count

                // Assuming address is a nested object
            }));
        }

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_user_location_details")
        writeFile(wb, "crompton_user_location_details_" + getCurrentDate() +  ".xlsx")
    }

    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6 !p-[20px]"}>
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    Location Demographics
                </h2>
                <div className="mb-6 flex items-center justify-center">
                    <select id="stateCityBox" onChange={handleStateCityDropDown}
                            className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                        <option value="State">State</option>
                        <option value="City">City</option>
                    </select>
                    <button className=" mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                            onClick={exportLocationData}>
                        Export Data
                    </button>
                </div>
            </div>

            <div className="mt-8 overflow-y-auto xl:overflow-x-hidden">
                <table className="w-full" variant="simple" color="gray-500" mb="24px">
                    <thead key= "unique" id= "unique">
                    <tr key= "unique1" id= "unique1">
                        <th key= "1"
                            className="border-b border-gray-200 pr-16 pb-[10px] text-start dark:!border-navy-700">
                            <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                                SR
                            </div>
                        </th>
                        <th key= "2"
                            className="border-b border-gray-200 pr-16 pb-[10px] text-start dark:!border-navy-700">
                            {selectedValue === "State" ?
                                <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                                    STATE
                                </div>
                                :
                                <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                                    CITY
                                </div>
                            }

                        </th>
                        <th key= "3"
                            className="border-b border-gray-200 pr-16 pb-[10px] text-start dark:!border-navy-700">
                            <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                                COUNT
                            </div>
                        </th>
                        <th key= "4"
                            className="border-b border-gray-200 pr-16 pb-[10px] text-start dark:!border-navy-700">
                            <div className="text-xs font-bold tracking-wide text-gray-600 lg:text-xs">
                                PERCENTAGE
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>

                    {locationJsonResult.slice(pg * rpg, pg * rpg + rpg).map((Val, index) => (
                        <tr>
                            <td className="pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    {/* <Checkbox />*/}
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {(pg * rpg) + index + 1}
                                    </p>
                                </div>
                            </td>
                            <td className="pt-[14px] pb-[16px] sm:text-[14px]">
                                {selectedValue === "State" ?
                                <div className="flex items-center gap-2">
                                    {/* <Checkbox />*/}
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {Val.state}
                                    </p>
                                </div>
                                :
                                <div className="flex items-center gap-2">
                                    {/* <Checkbox />*/}
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {Val.city}
                                    </p>
                                </div>
                                }
                            </td>
                            <td className="pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    {/* <Checkbox />*/}
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {Val.count}
                                    </p>
                                </div>
                            </td>
                            <td className="pt-[14px] pb-[16px] sm:text-[14px]">
                                <div className="flex items-center gap-2">
                                    {/* <Checkbox />*/}
                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                        {((Val.count / total) * 100).toFixed(1)}
                                    </p>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <CustomPagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={locationJsonResult.length}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </Card>
    );
    /*<LocationDemographicsTrend
        columnsData={[
            {
                Header: "SR",
                accessor: "sr",
            },
            {
                Header: "STATE",
                accessor: "state",
            },
            {
                Header: "COUNT",
                accessor: "count",
            },
        ]}
        tableData={locationJsonResult}
    />*/

};

export default LocationDataStateCityWise;
